export type ManeuverTackEntry = 'PORT' | 'STBD' | null;

export function rowTwaEntry(row: Record<string, unknown>): number | null {
  const raw = row.twa_entry ?? row.Twa_entry;
  if (raw == null) return null;
  const n = Number(raw);
  return Number.isFinite(n) ? n : null;
}

export function applyManeuverEntrySide(
  data: Record<string, unknown>[],
  entry: ManeuverTackEntry
): Record<string, unknown>[] {
  if (entry == null) return data;
  return data.filter((row) => {
    const twa = rowTwaEntry(row);
    if (twa == null) return false;
    return entry === 'PORT' ? twa < 0 : twa > 0;
  });
}
